<template>
    <a class="d-flex align-items-center position-relative" href="javascript:void(0)" @click="openCart">
        <span class="carrello-nr" v-text="counter"></span>
        <img class="m-0" height="29" :src="'/images/area-utente/cart-' + theme + '.svg'" alt="icona" />
    </a>
</template>
<style lang="scss" scoped>

    .carrello-nr{
        text-align: center;
        bottom: 3px;
        right: 1px;
        color: #ffffff;
        position: absolute;
        z-index: 10;
        font-size: .65rem;
        width: 13px;

        .menu--version-4 &, .menu--version-3 & {
            color: #1a1a1a;
        }

        @media (max-width:1199px) {
            bottom:2px;
        }

    }

</style>
<script>
export default {
    props: ['initCounter', 'cartLink', 'theme'],
    data() {
        return {
            counter: 0
        }
    },
    mounted() {
        this.counter = parseInt(this.initCounter);
        this.$eventHub.$on('cart.added', payload => {
            this.counter = parseInt(payload.count);
        });

        this.$eventHub.$on('cart.updated.simpleQty', payload => {
            this.counter = payload;
        });
    },
    beforeDestroy() {
        this.$eventHub.$off('cart.added');
        this.$eventHub.$off('cart.updated.simpleQty');
    },
    methods: {
        openCart() {
            if($(window).width() < 992 || this.counter == 0) {
                window.location.href = this.$root.langRoute('/carrello');
            }else{
                this.$eventHub.$emit('cart.show', {});
            }
        },
    }
}
</script>
